/*
 * Module for initializing our usage of the what-input plugin
 */

rs.module("common/what-input", [], function () {

    //
    // Initialize the what-input module
    // 
    function initialize() {

        // By default what input includes shift (key 16).  We want shift to trigger a transfer of intent 
        // from mouse to keyboard (and thereby show focus rings)
        whatInput.ignoreKeys([
            17, // control
            18, // alt
            91, // Windows key / left Apple cmd
            93  // Windows menu / right Apple cmd
        ]);
    }

    var exports = {
        initialize: initialize
    };

    return exports;
});